import { Apartment } from '../../../types/apartments'

/** Fiksumyynti-sovelluksen osoite samassa ympäristössä kuin tämä frontti */
export const getFiksumyyntiAppUrl = (): string => {
  const host = window.location.hostname
  if (host.includes('localhost') || host.startsWith('dev.')) {
    return 'https://dev.fiksumyynti.fi'
  }
  if (host.startsWith('test.')) {
    return 'https://test.fiksumyynti.fi'
  }
  return 'https://app.fiksumyynti.fi'
}

export const getFiksumyyntiListingUrl = (code: string): string =>
  `${getFiksumyyntiAppUrl()}/listing/${code}`

/** Onko vuokrakohteesta jo luotu myynti-ilmoitus (backend linkittää recordit cross-createssa) */
export const hasSaleListing = (apartment?: Apartment): boolean =>
  (apartment?.linkedApartments || []).some(link => link.productType === 'smartsale')
